import REGEX from './regex';

// In some cases we use validation from uuid npm package, so it's simply cloned from
// https://github.com/uuidjs/uuid/blob/main/src/validate.ts
export function validate(uuid: unknown) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}
